import React, { useState, useEffect } from "react";
import PopupForm from "./PopupForm.js"; // Import the Popup Form
import "./CyberSecurity.css"; // Import the CSS file for styling

// Cyber Security Services Data
const cyberServices = [
  {
    title: "Investigation Services",
    descriptions: [
      " Digital Forensics: Collection, analysis, and preservation of digital evidence,\n  Cybercrime Investigation: Investigation of cybercrimes, including hacking, identity theft, and online harassment.\n Incident Response: Immediate response to cyber incidents, including containment, eradication, recovery, and post-incident activities.\n Email Forensics: Analysis of email communications to investigate cybercrimes.\n Mobile Forensics: Analysis of mobile devices to recover data and investigate cybercrimes."
    ]
  },
  {
    title: "Analysis Services",
    descriptions: [
      " Digital Evidence Analysis: Analysis of digital evidence to identify patterns, anomalies, and potential security threats.\n Malware Analysis: Analysis of malware to understand its behavior, origin, and potential impact.\n Network Traffic Analysis: Analysis of network traffic to detect anomalies and potential security threats.\n Cloud Forensics: Analysis of cloud-based data to investigate cybercrimes.\n Database Forensics: Analysis of database systems to recover data and investigate cybercrimes."
    ]
  },
  {
    title: "Prevention Services",
    descriptions: [
      " Vulnerability Assessment: Identification of vulnerabilities in systems, networks, and applications.\n Penetration Testing: Simulation of cyber attacks to test defenses and identify weaknesses.\n Security Audits: Evaluation of security policies, procedures, and controls.\n Risk Assessment: Identification and assessment of potential security risks.\n Compliance Services: Ensuring compliance with regulatory requirements and industry standards."
    ]
  },
  {
    title: "Expert Testimony",
    descriptions: [
      " Expert Witness Services: Provision of expert testimony in court cases involving cybercrimes.\n Cyber Forensic Expertise: Provision of cyber forensic expertise to help resolve disputes and investigate cybercrimes."
    ]
  },
  {
    title: "Training and Awareness",
    descriptions: [
      " Cybersecurity Awareness Training: Provision of training programs to raise awareness about cybersecurity threats and best practices.\n Cyber Forensic Training: Provision of training programs for law enforcement and other organizations on cyber forensic investigation and analysis."
    ]
  },
  {
    title: "Additional Services",
    descriptions: [
      " Data Recovery: Recovery of deleted or corrupted data.\n Cybersecurity Consulting: Provision of expert advice on cybersecurity best practices.\n Incident Response Planning: Development of incident response plans.\n Digital Forensics Tools: Provision of digital forensics tools and software.\n Cybersecurity Maturity Assessments: Assessments of an organization's cybersecurity maturity."
    ]
  }
];

const CyberSecurity = () => {
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Function to go to the next service
  const nextService = () => {
    if (!isHovered) {
      const currentCategory = cyberServices[currentCategoryIndex];
      if (currentServiceIndex < currentCategory.descriptions.length - 1) {
        setCurrentServiceIndex((prevIndex) => prevIndex + 1);
      } else {
        // Move to the next category
        const nextCategoryIndex = (currentCategoryIndex + 1) % cyberServices.length;
        setCurrentCategoryIndex(nextCategoryIndex);
        setCurrentServiceIndex(0);
      }
    }
  };

  // Function to go to the previous service
  const prevService = () => {
    if (!isHovered) {
      if (currentServiceIndex > 0) {
        setCurrentServiceIndex((prevIndex) => prevIndex - 1);
      } else {
        // Move to the previous category
        const prevCategoryIndex = (currentCategoryIndex - 1 + cyberServices.length) % cyberServices.length;
        setCurrentCategoryIndex(prevCategoryIndex);
        setCurrentServiceIndex(cyberServices[prevCategoryIndex].descriptions.length - 1);
      }
    }
  };

  // Auto-slide services every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextService();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentCategoryIndex, currentServiceIndex, isHovered]);

  return (
    <div className="cyber-security-container">
      <section className="hero-cyber-section">
        <div className="hero-content">
          <h1>Cyber Security & Forensic Services</h1>
          <p>Protect your organization with advanced cyber forensic solutions designed to detect threats, prevent attacks, and secure your digital assets.</p>
          <div className="hero-buttons-wrapper">
            <button className="connect-now-btn" onClick={() => setIsPopupOpen(true)}>Connect Now!</button>
          </div>
        </div>
      </section>

      {/* About Section */}
       <section className="about-cyber-section">
         <div className="about-content">
           <div className="vector-image">
             <img src="./cybers.png" alt="Cyber Security Vector" />
           </div>

           <div className="about-text">
             <h2>Why Cyber Security Matters?</h2>
             <p>
               Cyber threats are becoming increasingly sophisticated, and businesses must stay one step ahead.
               Our cyber forensic services help identify security breaches, analyze vulnerabilities, and take
               corrective actions to protect sensitive data.
             </p>
             <ul>
               <li>🔹 Incident Response & Digital Forensics</li>
               <li>🔹 Malware & Cybercrime Investigation</li>
               <li>🔹 Security Audits & Risk Assessments</li>
             </ul>
           </div>
         </div>
       </section>



        {/* Features Section */}
      <section className="features-section">
          <h2 className="section-title">Why Choose Our Cyber Security Solutions?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">🔐</span>
              <h3>Advanced Security</h3>
              <p>Protect your organization from cyber threats and vulnerabilities.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">⚡</span>
              <h3>Rapid Response</h3>
              <p>Quick incident handling to minimize data loss and disruptions.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🔍</span>
              <h3>Forensic Expertise</h3>
              <p>In-depth analysis and investigation of cyber incidents.</p>
            </div>

          </div>
        </section>


      <section className="cyber-bottom-section">
        <h2>Explore Our Cyber Security Services</h2>
        <div className="service-carousel"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
          <div className="gst-service-card">
            <h3>{cyberServices[currentCategoryIndex].title}</h3>
            <p>{cyberServices[currentCategoryIndex].descriptions[currentServiceIndex]}</p>
            <div className="carousel-controls">
              <button onClick={prevService}>&#9665;</button>
              <button onClick={nextService}>&#9655;</button>
            </div>
          </div>
        </div>
      </section>
      

      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default CyberSecurity;
